<template>
  <div class="app">
    <!-- <button @click="addNewItem" class="add-item-btn">Add Krathong Item</button> -->
    <div class="items-container">
      <KrathongItem
        v-for="(item, index) in krathongItems"
        :key="index"
        :imageUrl="item.imageUrl"
        :caption="item.caption"
        :duration="item.duration"
        :topItem="item.topItem"
        :heightSize="item.heightSize"
        :KrathongZ="item.zIn"
      />
    </div>
    <!-- =========================================== wave =====================================-->
    <!-- <div class="waves"> -->
    <div class="waves">
      <!-- <div class="temple"></div> -->
      <div class="wave"></div>
      <div class="wave"></div>
      <!-- <div class="wave"></div> -->
      <div class="wave"></div>
      <div class="wave"></div>
    </div>

    <!-- ========================================= END =======================================-->
  </div>
</template>

<script>
import axios from "axios";
import KrathongItem from "../../../components/events/krathongItem.vue";
// import $ from "jquery";
export default {
  name: "App",
  components: {
    KrathongItem,
  },
  data() {
    return {
      krathongItems: [],
      token: "NDMyMTNDNUYtRkZFNy00NjI1LUIwNTQtMkQ0QTkzOTIyQTM3",
      imageNum: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      bottomNum: [495,520,585],
      sizeRandom: [150, 150, 200],
      zIndx: [19, 21, 29],
      items: [],
    };
  },
  created() {
    // Simulate fetching data from an API on component mount
    this.fetchKrathongItems();
    setInterval(() => {
      this.getNewItem();
    }, 5000);
  },
  methods: {
    getNewItem() {
      const token = this.token;
      const data = {
        token: token,
      };
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/miracle/get_lastdata",
          data,
          { headers }
        )
        .then((res) => {
          console.log("API =", res.data.signed_datas);
          const newItems = res.data.signed_datas;
          newItems.forEach((newKrathong) => {
            // ตรวจสอบว่า krathong นี้มีอยู่ใน array แล้วหรือไม่
            const exists = this.krathongItems.find(
              (existingItem) => existingItem.sign_no === newKrathong.sign_no
            );
            if (!exists) {
              this.addNewItem(
                newKrathong.sign_name,
                newKrathong.sign_no,
                newKrathong.sign_img
              );
              // ถ้ายังไม่มีใน array ให้เพิ่มเข้าไป
              // this.krathongs.push(newKrathong);

              // สร้าง element <img> สำหรับไอเทมใหม่
              // this.createImageTag(newKrathong);
            }
          });
        });
    },
    fetchKrathongItems() {
      // Simulate fetching data with a delay
      setTimeout(() => {
        const items = [
          {
            imageUrl: require("../../../assets/loykrathong/krathong_10.png"),
            caption: "สุขสันต์วันลอยกระทง",
            sign_no: 1,
            duration: this.getRandomDuration(),
            topItem: '490',
            zIn: 6,
            heightSize: 150,
          },
          {
            imageUrl: require("../../../assets/loykrathong/krathong_3.png"),
            caption: "ทำงานแบบสับ สับสนไปหมด",
            sign_no: 2,
            duration: this.getRandomDuration(),
            topItem: '520',
            zIn: 12,
            heightSize: 150,
          },
          {
            imageUrl: require("../../../assets/loykrathong/krathong_8.png"),
            caption: "ทำงานแบบสับ สับสนไปหมด",
            sign_no: 2,
            duration: this.getRandomDuration(),
            topItem: '585',
            zIn: 19,
            heightSize: 250,
          },
        ];
        this.krathongItems = items;
      }, 500);
    },
    addNewItem(cap, sign_no, sign_img) {
      // sign_img;
      // Add a new item dynamically with random properties
      const randpomindex = Math.floor(Math.random() * this.imageNum.length);
      const index = this.imageNum[randpomindex];

      const randpomZindx = Math.floor(Math.random() * this.zIndx.length);
      const Zindxx = this.zIndx[randpomZindx];

      const rBottom = Math.floor(Math.random() * this.bottomNum.length);
      const randomBottom = this.bottomNum[rBottom];
      // const chosenNumber = Math.floor(Math.random() * this.sizeRandom.length);
      // const randomSize = this.sizeRandom[chosenNumber];
      var avatar;
      if (sign_img !== null) {
        avatar = sign_img;
        // console.log(Zindxx);

        if (Zindxx === 19) {
          const newItem = {
            imageUrl: avatar,
            caption: cap,
            sign_no: sign_no,
            duration: this.getRandomDuration(),
            topItem: '40',
            heightSize: 100,
            zIn: 19,
            animationDelay: `${index * 2}s`,
          };
          this.krathongItems.push(newItem);
        } else if (Zindxx === 21) {
          const newItem = {
            imageUrl: avatar,
            caption: cap,
            sign_no: sign_no,
            duration: this.getRandomDuration(),
            topItem: '55',
            heightSize: 100,
            zIn: 21,
            animationDelay: `${index * 2}s`,
          };
          this.krathongItems.push(newItem);
        } else if (Zindxx === 29) {
          const newItem = {
            imageUrl: avatar,
            caption: cap,
            sign_no: sign_no,
            duration: this.getRandomDuration(),
            topItem: '70',
            heightSize: 100,
            zIn: 29,
            animationDelay: `${index * 2}s`,
          };
          this.krathongItems.push(newItem);
        }

        //   if (randomBottom == 100) {
        //   const newItem = {
        //     imageUrl:avatar ,
        //     caption: cap,
        //     sign_no: sign_no,
        //     duration: this.getRandomDuration(),
        //     topItem: randomBottom,
        //     heightSize: 100,
        //     zIn: 19,
        //     animationDelay: `${index * 2}s`,
        //   };
        //   this.krathongItems.push(newItem);
        // } else if (randomBottom == 150) {
        //   const newItem = {
        //     imageUrl: avatar,
        //     caption: cap,
        //     sign_no: sign_no,
        //     duration: this.getRandomDuration(),
        //     topItem: randomBottom,
        //     heightSize: 100,
        //     zIn: 20,
        //     animationDelay: `${index * 2}s`,
        //   };
        //   this.krathongItems.push(newItem);
        // } else if (randomBottom == 200) {
        //   const newItem = {
        //     imageUrl: avatar,
        //     caption: cap,
        //     sign_no: sign_no,
        //     duration: this.getRandomDuration(),
        //     topItem: randomBottom,
        //     heightSize:100,
        //     zIn: 12,
        //     animationDelay: `${index * 2}s`,
        //   };
        //   this.krathongItems.push(newItem);
        // } else if (randomBottom == 50) {
        //   const newItem = {
        //     imageUrl:avatar,
        //     caption: cap,
        //     sign_no: sign_no,
        //     duration: this.getRandomDuration(),
        //     topItem: randomBottom,
        //     heightSize: 100,
        //     zIn: 12,
        //     animationDelay: `${index * 2}s`,
        //   };
        //   this.krathongItems.push(newItem);
        // }
      } else {
        avatar = require("../../../assets/loykrathong/krathong_" +
          index +
          ".png");

        if (randomBottom == 495) {
          const newItem = {
            imageUrl: avatar,
            caption: cap,
            sign_no: sign_no,
            duration: this.getRandomDuration(),
            topItem: randomBottom,
            heightSize: 150,
            zIn: 6,
            animationDelay: `${index * 2}s`,
          };
          this.krathongItems.push(newItem);
          // 570,600
        } else if (randomBottom == 520) {
          const newItem = {
            imageUrl: avatar,
            caption: cap,
            sign_no: sign_no,
            duration: this.getRandomDuration(),
            topItem: randomBottom,
            heightSize: 150,
            zIn: 12,
            animationDelay: `${index * 2}s`,
          };
          this.krathongItems.push(newItem);
        } else if (randomBottom == 585) {
          const newItem = {
            imageUrl: avatar,
            caption: cap,
            sign_no: sign_no,
            duration: this.getRandomDuration(),
            topItem: randomBottom,
            heightSize: 200,
            zIn: 19,
            animationDelay: `${index * 2}s`,
          };
          this.krathongItems.push(newItem);
        } 
      }

      // if (randomBottom == 100) {
      //   const newItem = {
      //     imageUrl:avatar ,
      //     caption: cap,
      //     sign_no: sign_no,
      //     duration: this.getRandomDuration(),
      //     topItem: randomBottom,
      //     heightSize: 100,
      //     zIn: 19,
      //     animationDelay: `${index * 2}s`,
      //   };
      //   this.krathongItems.push(newItem);
      // } else if (randomBottom == 150) {
      //   const newItem = {
      //     imageUrl: avatar,
      //     caption: cap,
      //     sign_no: sign_no,
      //     duration: this.getRandomDuration(),
      //     topItem: randomBottom,
      //     heightSize: 150,
      //     zIn: 20,
      //     animationDelay: `${index * 2}s`,
      //   };
      //   this.krathongItems.push(newItem);
      // } else if (randomBottom == 200) {
      //   const newItem = {
      //     imageUrl: avatar,
      //     caption: cap,
      //     sign_no: sign_no,
      //     duration: this.getRandomDuration(),
      //     topItem: randomBottom,
      //     heightSize: 200,
      //     zIn: 12,
      //     animationDelay: `${index * 2}s`,
      //   };
      //   this.krathongItems.push(newItem);
      // } else if (randomBottom == 50) {
      //   const newItem = {
      //     imageUrl:avatar,
      //     caption: cap,
      //     sign_no: sign_no,
      //     duration: this.getRandomDuration(),
      //     topItem: randomBottom,
      //     heightSize: 100,
      //     zIn: 12,
      //     animationDelay: `${index * 2}s`,
      //   };
      //   this.krathongItems.push(newItem);
      // }

      // console.log(this.krathongItems);
    },
    getRandomDuration() {
      // Generate a random duration between 5 and 15 seconds for animation speed
      return Math.floor(Math.random() * 30) + 20;
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.app {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url(../../../assets/loykrathong/loyy.png);
  background-size: cover;
  background-position: center;
  /* background-image: linear-gradient(#c6d8ff, #fff); */
  /* background-image: linear-gradient(
    to top,
    #a262b0,
    #884e9d,
    #6e3c8a,
    #552978,
    #3b1866
  ); */
  overflow: hidden;
  z-index: -2;
}
.items-container {
  /* position: relative;
  width: 100vw;
  height: 800px;
  overflow: hidden;
  bottom: 1px;
  top: 400px;*/

  z-index: 999;
}
/*wave*/

.wave1,
.wave2,
.wave3 {
  position: absolute;
  width: 200%;
  height: 10px;
  bottom: 0;
  animation: move 16s linear alternate infinite;
  z-index: -1;
}
.wave1:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 80px;
  background-repeat: repeat;
  background-size: 80px 80px;
  background-image: radial-gradient(
    circle at 25px -5px,
    transparent 22px,
    #0f70d1 23px
  );
}
.wave1:after {
  content: "";
  position: absolute;
  left: -40px;
  right: 0;
  bottom: 0;
  height: 100px;
  background-repeat: repeat;
  background-size: 80px 100px;
  background-image: radial-gradient(
    circle at 25px 25px,
    #0f70d1 18px,
    transparent 19px
  );
}
.wave2 {
  bottom: 50px;
  left: -40px;
  z-index: -2;
  animation: move 8s alternate-reverse ease-in-out infinite;
}
.wave2:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 80px;
  background-repeat: repeat;
  background-size: 80px 80px;
  background-image: radial-gradient(
    circle at 25px -5px,
    transparent 22px,
    #0f65a1 23px
  );
}
.wave2:after {
  content: "";
  position: absolute;
  left: -40px;
  right: 0;
  bottom: 0;
  height: 100px;
  background-repeat: repeat;
  background-size: 80px 100px;
  background-image: radial-gradient(
    circle at 25px 25px,
    #0f65a1 18px,
    transparent 19px
  );
}
.wave3 {
  bottom: 100px;
  z-index: -3;
  animation: move 16s alternate-reverse linear infinite;
}
.wave3:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 80px;
  background-repeat: repeat;
  background-size: 80px 80px;
  background-image: radial-gradient(
    circle at 25px -5px,
    transparent 22px,
    #0f6081 23px
  );
}
.wave3:after {
  content: "";
  position: absolute;
  left: -40px;
  right: 0;
  bottom: 0;
  height: 100px;
  background-repeat: repeat;
  background-size: 80px 100px;
  background-image: radial-gradient(
    circle at 25px 25px,
    #0f6081 18px,
    transparent 19px
  );
}
@keyframes move {
  0% {
    transform: translateX(-200px);
  }
  100% {
    transform: translateX(-20px);
  }
}
.wave {
  position: absolute;
  left: 0;
  bottom: 0;
  height: auto;
  width: 100%;
  /* background-repeat: repeat-x, no-repeat; */
}

.wave {
  /* position: absolute;
  left: 0;
  bottom: 0;
  height: auto;
  width: 100%; */
  /* background-repeat: repeat-x, no-repeat; */
  position: absolute;
  left: 0;
  bottom: 0px;
  height: auto;
  width: 100%;
}

/*.wave:nth-child(1) {
  z-index: 21;
  height: 150px;
  bottom: -10px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(255, 240, 163)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
    linear-gradient(#fff0a3, #fff0a3);
  background-size: 200px 150px, 200% 100%;
  background-position: 0 0, 0 100px;
  background-repeat: repeat-x;
  -webkit-animation: 20s linear 0s infinite normal none running ani_wave;
  animation: 32s linear 0s infinite normal none running ani_wave;
}*/

.wave:nth-child(2) {
  z-index: 20;
  height: 180px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(253, 225, 125)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
    linear-gradient(#fde17d, #fde17d);
  background-size: 200px 140px, 200% 100%;
  background-position: 0 0, center 95px;
  background-repeat: repeat-x;
  -webkit-animation: 25s linear 0s infinite normal none running ani_wave;
  animation: 20s linear 0s infinite normal none running ani_wave;
}
.wave:nth-child(3) {
  z-index: 13;
  height: 230px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(249, 211, 99)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
    linear-gradient(#f9d363, #f9d363);
  background-size: 160px 50px, 200% 100%;
  background-position: 0 0, center 40px;
  background-repeat: repeat-x;
  -webkit-animation: 35s linear 0s infinite normal none running ani_wave;
  animation: 40s linear 0s infinite normal none running ani_wave;
  /* #e9c136 (233, 193, 54)*/
}
.wave:nth-child(4) {
  z-index: 7;
  height: 320px;

  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(233, 193, 54)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
    linear-gradient(to right, #e9c136, #e9c136);

  background-size: 160px 60px, 200% 100%;
  background-position: 0 0, 0 40px;
  background-repeat: repeat-x;
  -webkit-animation: 25s linear 0s infinite normal none running ani_wave;
  animation: 25s linear 0s infinite normal none running ani_wave;
}
/* .wave:nth-child(5) {
      z-index: 4;
      height: 400px;
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(	21, 99, 177)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
       linear-gradient(to right, #1563b1, #1563b1);
      background-size: 90px 25px, 200% 100%;
      background-position: 0 0, 0 20px;
      animation: ani_wave5 2s linear alternate infinite;
    } */
@keyframes ani_wave1 {
  /* 0% {
      background-position-x: 0;
    }
    100% {
      background-position-x: -100px;
    } */
}

@-webkit-keyframes ani_wave {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: 1080px;
  }
}

@keyframes ani_wave {
  from {
    /* transform: translateX(-50px); */
    background-position-x: 0;
  }
  to {
    /* transform: translateX(50vw); */
    background-position-x: 1080px;
  }
}
</style>
